import { put, call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';
import { setRedirect } from 'auth/actions';
import { sprintInsurance, bypassedInsurance } from 'app/routes';

export function* sprintInsuranceNavigate({ subId }) {
  yield put(setRedirect(sprintInsurance(subId)));
  yield call(authenticateUser);
};

export function* bypassedInsuranceNavigate({ subId }) {
  yield put(setRedirect(bypassedInsurance(subId)));
  yield call(authenticateUser);
};
